<p-dialog
  header="Inspector Location"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{width: '70vw', maxWidth: '800px', minWidth: '500px'}">

  <div class="location-map-content">
    <!-- View Mode Indicator -->
    <div class="view-mode-indicator">
      <i class="pi" [ngClass]="mapViewMode === 'path' ? 'pi-map' : 'pi-map-marker'"></i>
      <span><strong>{{ viewModeLabel }}</strong></span>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="map-loading">
      <p-progressSpinner
        styleClass="spinner-small"
        strokeWidth="4"
        animationDuration="1s">
      </p-progressSpinner>
      <p>Loading map...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="map-error">
      <i class="pi pi-exclamation-triangle"></i>
      <p>{{ error }}</p>
    </div>

    <!-- Map Image -->
    <div *ngIf="mapImageUrl && !loading && !error" class="map-container">
      <img
        [src]="mapImageUrl"
        alt="Location Map"
        class="map-image">

      <div class="map-legend">
        <div *ngIf="mapViewMode === 'path'" class="legend-items">
          <div class="legend-item">
            <span class="marker-dot start"></span>
            <span>Start (S)</span>
          </div>
          <div class="legend-item">
            <span class="marker-dot intermediate"></span>
            <span>Waypoints</span>
          </div>
          <div class="legend-item">
            <span class="marker-dot end"></span>
            <span>Current (E)</span>
          </div>
          <div class="legend-item">
            <span class="accuracy-circle"></span>
            <span>Accuracy radius</span>
          </div>
        </div>
        <div *ngIf="mapViewMode === 'latest'" class="legend-items">
          <div class="legend-item">
            <span class="marker-dot end"></span>
            <span>Current location</span>
          </div>
          <div class="legend-item">
            <span class="accuracy-circle"></span>
            <span>Accuracy radius</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Message -->
    <div class="location-info-message" *ngIf="!loading && !error">
      <i class="pi pi-info-circle"></i>
      <span>Location tracking updates every 30 seconds. Accuracy circles show the approximate precision of each measurement.</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Close"
      icon="pi pi-times"
      [text]="true"
      (onClick)="closeDialog()">
    </p-button>
    <p-button
      [label]="toggleButtonLabel"
      [icon]="mapViewMode === 'path' ? 'pi-map-marker' : 'pi-map'"
      [outlined]="true"
      (onClick)="toggleViewMode()"
      [disabled]="loading">
    </p-button>
    <p-button
      label="Open in Google Maps"
      icon="pi pi-external-link"
      (onClick)="openInGoogleMaps()"
      [disabled]="!googleMapsUrl || loading">
    </p-button>
  </ng-template>
</p-dialog>
